export default __webpack_public_path__ + "assets/fonts/b6ffcbe637880bfa25519b3999decf4d.woff";